//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.tr`
    width: 100%;
    line-height: 30px;
`;
export const TDef = styled.td`
    margin: 0;
    padding: 0;
`;
const TDefContent = styled.div`
    background-color: var(--light-blue-1);
    height: 70px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    &.first-cell { 
        padding-left: 15px;
    }
    &.last-cell { 
        padding-right: 15px;
    }
    &.first-row {
        padding-top: 12px;
        &.first-cell { 
            border-top-left-radius: 8px; }
        &.last-cell { 
            border-top-right-radius: 8px; }
    }
    &.last-row, &.only-one {
        padding-bottom: 12px;
        &.first-cell { 
            border-bottom-left-radius: 8px; 
        }
        &.last-cell { 
            border-bottom-right-radius: 8px; }
    }
`;
export const WrapperCell = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--light-1);
    width: 100%;
    height: 95%;
    transition: 2s;
    &.is-pinned {
        background-color: var(--light-blue-2);
    }
    &:not(.first-row, .last-row) {
        height: 55px;
    }
    &.first-cell {
        border-top-left-radius: 8px; 
        border-bottom-left-radius: 8px; 
    }
    &.last-cell {
        border-top-right-radius: 8px; 
        border-bottom-right-radius: 8px; 
    }
    & span {
        color: var(--light-gray-5);
        font-size: 14px;
        text-align: center;
    }
`;
export const StudentIdCell = styled(TDefContent)`
    min-width: 150px;
    & span {
        font-weight: bold;
    }
`;
export const StudentNameCell = styled(TDefContent)`
    min-width: 380px;
`;
export const StudentStateCell = styled(TDefContent)`
    min-width: 150px;
`;
export const StudentInscriptionDateCell = styled(TDefContent)`
    min-width: 200px;
`;
export const StudentSanctionDateCell = styled(TDefContent)`
    min-width: 200px;
`;
export const StudentAttendanceCell = styled(TDefContent)`
    min-width: 170px;
    & > div {
        display: flex;
        justify-content: flex-end;
    }
`;